<template>
  <div class="layout">
    <PcHeader v-if="!isH5" />
    <SearchGame v-if="isH5" />
    <div class="wrapp">
      <DownBack v-if="isH5" />
      <div class="content">
        <div class="game-list" v-if="saleSlice && saleSlice.length > 0">
          <div class="list-title">
            <div class="title-word">SALES</div>
            <a class="more" href="javascript:void(0)" @click="moreSale">More &gt;&gt;</a>
          </div>
          <SaleGame v-for="(item, index) in saleSlice" :key="index" :item="item" ></SaleGame>
        </div>
        <div class="game-list">
          <div class="list-title">
            <div class="title-word">HOT TODAY</div>
          </div>
          <template >
            <Onegame v-for="(item, index) in datas" :key="index" :item="item" />
          </template>
        </div>

        <van-pagination
          v-if="datas.length >1"
          v-model="currentPage" 
          :total-items="total" 
          :items-per-page="20"
          class="pages"
          :force-ellipses="true"
          @change="changePage"
        >
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        </van-pagination>
        <div class="email" v-if="datas != ''">hotplaygames@hotmail.com</div>
      </div>
    </div>
  </div>
</template>
<script>
import Onegame from '@/components/onegame.vue'
import SaleGame from '@/components/saleGame.vue'
import DownBack from '@/components/downBack.vue'
import SearchGame from '@/components/searchGame.vue'
import PcHeader from '@/components/PcHeader.vue'

import { getallapp, discountlist } from '@/util/ourplay'
import resizeMixin from '@/mixins/resizeMixin'

export default {
  components: {
    Onegame,
    SaleGame,
    DownBack,
    SearchGame,
    PcHeader
  },
  mixins: [resizeMixin],
  data () {
    return {
      datas:[],
      currentPage:1,
      page:1,
      total:940,
      ver:[],
      title:'',
      sales: []
    }
  },
  computed: {
    saleSlice () {
      return this.sales.slice(0, 4)
    },
  },
  methods: {
    async changePage( p ) {
      this.page = p
      let res = await getallapp({ page: this.page, pageSize: 20 })
      this.datas = res.data
      this.total = res.total
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      sessionStorage.setItem("keypage", this.page)
    },
    async disCountlist () {
      let res = await discountlist()
      this.sales = res.data
    },
    moreSale () {
      this.$router.push({ path: './saleAll' })
    }
  },
  async created() {
    this.page = sessionStorage.getItem("keypage") || 1
    this.currentPage = Number( this.page )
    let res2 = await getallapp({ page: this.page, pageSize: 20 })
    this.datas = res2.data
    this.total = res2.total
    this.disCountlist()
  }
}

</script>
<style lang="scss" scoped>
.layout {
  .list-title {
    margin: 12px 0;
    padding: 12px 0;
    height: 20px;
    .title-word {
      text-align: left;
      padding-left: 12px;
      font-size: 18px;
      font-family: Roboto-Medium,Roboto;
      font-weight: 800;
      color: rgba(51,51,51,1);
    }
    .more {
      float: right;
      font-size: 12px;
      font-family: Roboto-Regular,Roboto;
      font-weight: 400;
      color: rgba(153,153,153,1);
    }
  }
  .email {
    margin: 12px 0;
    color: #333;
    opacity: .7;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HelloWorld.vue